import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center pt-24 overflow-hidden bg-[#07113a]">
      {/* Background elements */}
      <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-[#3b82f6]/5 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-[0.03] pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block text-[#3b82f6] font-bold tracking-[0.2em] uppercase text-sm mb-6">
              Built in Rapid City
            </span>
            <h1 className="text-6xl md:text-8xl font-black text-white mb-8 tracking-tight leading-[1.05]">
              Custom websites<br />and apps for<br />growing businesses.
            </h1>
            <p className="text-xl md:text-2xl text-[#94a3b8] mb-6 font-bold tracking-tight uppercase">
              Built in Rapid City by the creator of more than a dozen digital products.
            </p>
            <p className="text-xl md:text-2xl text-[#e2e8f0] mb-12 leading-relaxed max-w-2xl font-medium">
              Crucible Lab helps businesses launch professional websites, customer-facing apps, loyalty experiences, ordering and booking tools, and custom software. Work directly with Claton Butcher from the first conversation through launch and ongoing improvement.
            </p>
            <div className="flex flex-col sm:flex-row gap-5">
              <Link
                to="/contact"
                className="bg-[#3b82f6] text-white px-10 py-5 rounded-2xl font-black text-xl hover:bg-[#2563eb] transition-all text-center shadow-2xl shadow-[#3b82f6]/30 uppercase tracking-widest"
              >
                Start your project
              </Link>
              <Link
                to="/portfolio"
                className="bg-[#2a3658] text-white border border-[#344271] px-10 py-5 rounded-2xl font-black text-xl hover:bg-[#344271] transition-all text-center backdrop-blur-sm uppercase tracking-widest"
              >
                Explore products
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;